export const REGISTRATION_DIALOGUE_SEEN_SOURCE_EVENT_NAME =
  'registration_dialogue_seen_source';

export enum RegistrationDialogueSource {
  FAVORITE_LOT_HEART_BUTTON = 'fave_lot_heart_button',
}

export interface RegistrationDialogueSeenSourceEvent {
  event: typeof REGISTRATION_DIALOGUE_SEEN_SOURCE_EVENT_NAME;
  eventPayload: {
    source: RegistrationDialogueSource;
  };
}
